import {
  type HttpEvent,
  HttpHandler,
  type HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthUserService } from '../auth-user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authUserService = inject(AuthUserService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // #authRoutes should be synchronized with the server
    if (
      req.url.startsWith('/api/accounts/') ||
      req.url === '/api/invites' ||
      req.url.startsWith('/api/invites/') ||
      req.url === '/api/orgs' ||
      req.url.startsWith('/api/orgs/') ||
      req.url.startsWith('/api/super-admin/') ||
      (req.url.startsWith('/api/web-socket/') &&
        req.url !== '/api/web-socket/url') ||
      req.url === '/api/auth/logout'
    ) {
      let accountId: string;
      if (req.url.startsWith('/api/orgs/')) {
        const orgId = req.url.split('/')[3];
        const authUser = this.authUserService.getAuthUserOrgObj({ orgId });
        accountId = authUser.accountId;
      } else if (req.url.startsWith('/api/accounts/')) {
        const pathAccountId = req.url.split('/')[3];
        const authUser = this.authUserService.getAuthUserOrgObj({
          accountId: pathAccountId,
        });
        accountId = authUser.accountId;
      } else {
        const account = this.authUserService.getAccount();
        if (!account) throw new Error('not logged in');
        accountId = account.accountId;
      }

      const cloned = req.clone({
        headers: req.headers.set('account-id', accountId),
      });
      return next.handle(cloned);
    }
    // Default
    return next.handle(req);
  }
}
